<template lang="pug">
    .contactpage
        .section.header(v-if="headerSections.length" v-for="(section, index) in headerSections" :key="section.id" :class="section.key")
            Banner(v-if="section.key === 'banner'" :section="section")
            Slider(v-if="section.key === 'slider'" :section="section")
        .container(ref="container" )
            .socialmedia-wrapper
                SocialMediaButtons(:style="{ right: computedMargin }")
            .section.body(v-if="mainSections.length" v-for="(section, index) in mainSections" :key="section.id" :class="section.key")
                Heading(v-if="section.key === 'heading'" :section="section")
                ImageSection(v-else-if="section.key === 'image'" :section="section")
                Post(v-else-if="section.key === 'post'" :section="section")
                Form.column.is-6(v-else-if="section.key === 'form'" :section="section")
</template>

<script>

import { debounce } from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Post from '@/components/Post'
import Slider from '@/components/Slider'
import Form from '@/components/Form'
import Banner from '@/components/Banner'
import SocialMediaButtons from '@/components/SocialMediaButtons'


export default {
    name: 'ContactPage',
    components: {
        Heading,
        ImageSection,
        Post,
        Slider,
        Form,
        Banner,
        SocialMediaButtons
    },
    data() {
        return {
            margin: 0
        }
    },
    computed: {
        headerSections() {
            return this.filteredSections.filter(section => section.area === 'header')
        },
        mainSections() {
            return this.filteredSections.filter(section => section.area === 'main')
        },
        computedMargin() {
            return '-' + this.margin + 'px'
        },
        filteredSections() {
            return this.sections.filter(section => {
                return section.key === 'heading'
                    || section.key === 'image'
                    || section.key === 'post'
                    || section.key === 'slider'
                    || section.key === 'form'
                    || section.key === 'banner'
            })
        },
        ...mapGetters({
            sections: 'currentPage/sections',
        })
    },
    methods: {
        getRightMargin() {
            const style = getComputedStyle(this.$refs.container)
            this.margin = parseFloat(style.marginRight)
        }
    },
    mounted() {
        const getRightMarginResize = () => {
            this.getRightMargin()
        }
        window.addEventListener('resize', debounce(getRightMarginResize, 100))
        getRightMarginResize()
    }
}

</script>

<style lang="sass" scoped>
    @import "~bulma/sass/utilities/mixins"
    .socialmedia-wrapper
        +mobile
            display: none
        +touch
            display: none
    // .contactpage
    //     & > .section
    //         padding-bottom: 0
    //         &:first-child
    //             padding-top: 4.5rem
    //         &:last-child
    //             padding-bottom: 4.5rem
    //         &.category-page-teaser
    //             display: none
    .section.slider,
    .section.banner
        padding: 0
    .section.header
        padding-bottom: 3rem
    .section.heading
        text-transform: initial
</style>
